<template>
  <div>
  <v-card style="background-color: #ECEFF1" class="transparent elevation-0">
    <v-container container--fluid pb-0>
      <v-card-title>
        <h1>Clients</h1>
      </v-card-title>
      <v-card-actions>
       <v-row justify="space-between">
          <v-col cols="12" md="4">
            <v-text-field
              v-model="search"
              prepend-inner-icon="search"
              label="Search...">
            </v-text-field>
          </v-col>
          <v-col md="3" cols="12" style="display: inline-flex" class="align-center">
                <v-switch
                  label="Show Inactive"
                  v-model="inactiveSwitch"
                ></v-switch>
            <v-spacer></v-spacer>
                <v-tooltip top color="secondary">
                  <template v-slot:activator="{ on }">
                    <v-btn icon color="green" dark to="/new-client" v-on="on">
                      <v-icon>person_add</v-icon>
                    </v-btn>
                  </template>
                  <span>Create a new client</span>
                </v-tooltip>
          </v-col>
       </v-row>
      </v-card-actions>
    </v-container>

    <v-divider color="#42a5f5"></v-divider>

    <v-data-table
      :items="renderedClients"
      :headers="headers"
      :search="search"
      :items-per-page="-1"
    >
      <template v-slot:item="props">
        <tr v-bind:class="{odd: props.index % 2, even: !props.index % 2}">
          <td
            style="text-align: center"
            v-for="(header, index) in headers"
            v-if="header.text !== 'Edit'"
            :key="index">
            {{props.item[header.value]}}
          </td>
          <td
            style="text-align: center"
            v-if="editPermission"
          >
            <v-tooltip top color="secondary">
              <template v-slot:activator="{ on }">
                <v-btn icon :to="'/edit-client?id=' + props.item.id" v-on="on">
                  <v-icon color="blue">
                    edit
                  </v-icon>
                </v-btn>
              </template>
              <span>Edit Client</span>
            </v-tooltip>
          </td>
        </tr>
      </template>
    </v-data-table>
  </v-card>
  </div>
</template>

<script>
  import axios from 'axios'

  // @group ClientsPage
  // Clients table with edit buttons
  export default {
    name: "ClientDataTable",
    props: {
      // Array of clients
      clients: Array,
    },
    data() {
      return {
        inactiveSwitch: false,
        search: '',
      }
    },
    computed: {
      renderedClients() {
        // Clients displayed in the data-table (filtered depending on the posiition of the inactive toggle)
        let renderClients = this.clients.filter((client) => {
          return client.active === true || this.inactiveSwitch
        });
        return renderClients
      },
      editPermission() {
        return this.$store.getters['auth/hasPermission']('client_edit');
      },
      isInternalUser() {
        return this.$store.getters['auth/isInternalUser'];
      },
      headers() {
        let headers = [
          {text: 'ID', value: 'id', align: 'center'},
          {text: 'Ops Email', value: 'ops_email', align: 'center'},
          {text: 'Billing Email', value: 'billing_email', align: 'center'},
          {text: 'CC Email', value: 'cc_contact_email', align: 'center'},
          {text: 'Active', value: 'active', align: 'center'},
          {text: 'Product Type', value: 'product_type', align: 'center'},
          {text: 'Download Zone Data', value: '', align: 'center'},
          {text: 'Pick Pack', value: 'pick_pack', align: 'center'}
        ];
        if (this.isInternalUser) {
          headers.push({text: 'Client Name', value: 'name', align: 'center'});
        }
        if (this.editPermission) {
          headers.push(
            {text: 'Edit', value: '', align: 'center', sortable: false},
          )
        }

        return headers;
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/util/Clients/ClientDataTable.vue